module.exports = __webpack_public_path__ + "e5b8ab73e47d055889b69ae84c5fcabd.svg";